import styled from 'styled-components';
import { TitleWithBenefitsStyled } from '../TitleWithBenefitsStyled';
import { rem } from 'polished';

export const TitleWithBenefitsStyledDS = styled(TitleWithBenefitsStyled)`
    .title {
        font-size: ${rem('32px')};
    }

    .specs > .specs-title {
        font-size: ${rem('20px')};
    }

    .benefits {
        padding-left: 0;
        background: none;
        .bullet-points.allow-bullet-points {
            & > li {
                list-style: initial;
            }
            padding-left: ${rem('16px')};

            .offer {
                svg {
                    circle {
                        fill: ${({ theme }) => theme.colors.white};
                        stroke: ${({ theme }) => theme.colors.black1};
                    }
                }
            }
        }
        .bullet-points.disable-bullet-points {
            list-style: none;
        }
    }
`;
